import { useQuery } from '@tanstack/react-query';

import { customerApi } from '../api/customerApi';

export const useCustomerRecommendation = (
  customerId: string,
  startDate: string,
  endDate: string,
  page: number,
  limit: number
) => {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: [
      'customer-recommendations',
      customerId,
      startDate,
      endDate,
      page,
      limit,
    ],
    queryFn: () =>
      customerApi.fetchCustomerRecommendations(
        customerId,
        startDate,
        endDate,
        page,
        limit
      ),
    refetchOnWindowFocus: false,
    enabled: !!customerId,
  });

  const refetchOnError = () => {
    refetch();
  };

  return {
    customerRecommendations: data?.rows,
    totalCount: Number(data?.count),
    pageSize: limit,
    isLoading,
    isError,
    refetchOnError,
  };
};
